import Link from 'next/link'
import { useClearRefinements } from 'react-instantsearch'

import { getFilterValues } from '@/lib/utils/algolia'

type FilterRefinementPillboxListProps = {
  filters: {
    filter_label: string
    filter_algolia_name?: string
    filter_link: string
  }[]
}

export default function FilterRefinementPillboxList({
  filters,
}: FilterRefinementPillboxListProps): JSX.Element {
  const { refine } = useClearRefinements()
  const urlAppliedFilters = getFilterValues()
  const urlAppliedFilterValues = urlAppliedFilters?.refinementList
    ? Object.values(urlAppliedFilters.refinementList).flat()
    : []

  if (!filters) {
    return null
  }

  function handleTabDeselect(
    event: React.MouseEvent<HTMLAnchorElement>,
    isFiltered: boolean,
    redirectUrl: string,
  ) {
    event.preventDefault()

    if (isFiltered) {
      refine()
    } else {
      window.location.href = redirectUrl
    }
  }

  const filterTabs = filters.map((item) => {
    const isFiltered =
      urlAppliedFilterValues.includes(item.filter_label) ||
      (item.filter_algolia_name && urlAppliedFilterValues.includes(item.filter_algolia_name))
    const activeClass = isFiltered ? 'bg-black text-white' : 'bg-grey-100 text-fg-title'

    return (
      <li key={item.filter_label}>
        <Link
          href={item.filter_link}
          onClick={(event) => handleTabDeselect(event, isFiltered, item.filter_link)}
          className={`${activeClass} filter-label block cursor-pointer whitespace-nowrap rounded-full border border-grey-100 px-s py-xxs text-[length:--p-xs-size] font-normal transition-colors hover:border-black`}>
          {item.filter_label}
        </Link>
      </li>
    )
  })

  return (
    <nav className="ais-Menu border-grey-300 m:hidden xs-up:pl-s m-up:border-l">
      <ul className="flex gap-x-xs gap-y-xxs">{filterTabs}</ul>
    </nav>
  )
}
